import { useQuery } from '@tanstack/react-query';

import { api, type Paginated } from '@/lib/api';
import { fmtDate, fmtUsd, fmtInt } from '@/lib/format';

interface PurchaseRow {
  id: number;
  wine: { name: string; winery?: { name: string } };
  purchase_date: string;
  quantity: number;
  unit_price: number;
  currency: string;
  unit_price_usd: number;
  total_price_usd: number;
  // El backend devuelve un objeto Supplier (o null) + un supplier_label ya formateado.
  supplier: { id: number; name: string } | null;
  supplier_label: string | null;
}

export function PurchasesPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['purchases'],
    queryFn: async () => (await api.get<Paginated<PurchaseRow>>('/purchases')).data,
  });

  return (
    <div className="p-8">
      <header className="flex items-end justify-between mb-6">
        <div>
          <h1 className="text-2xl font-medium">Compras</h1>
          <p className="text-sm text-notion-500">
            Historial de compras con precios congelados a la fecha de la operación.
          </p>
        </div>
      </header>

      <div className="card overflow-x-auto">
        {isLoading ? (
          <div className="p-12 text-center text-notion-500">Cargando…</div>
        ) : !data?.data.length ? (
          <div className="p-12 text-center text-notion-500">Aún no registraste compras.</div>
        ) : (
          <table className="table-base min-w-[640px]">
            <thead className="bg-white">
              <tr>
                <th>Fecha</th>
                <th>Vino</th>
                <th>Cant.</th>
                <th>Precio</th>
                <th>USD/bot</th>
                <th>Total USD</th>
                <th>Proveedor</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((p) => (
                <tr key={p.id} className="hover:bg-white">
                  <td>{fmtDate(p.purchase_date)}</td>
                  <td>
                    <div className="font-medium">{p.wine.name}</div>
                    <div className="text-xs text-notion-500">{p.wine.winery?.name}</div>
                  </td>
                  <td>{fmtInt(p.quantity)}</td>
                  <td>{p.currency} {p.unit_price.toLocaleString('es-AR')}</td>
                  <td>{fmtUsd(p.unit_price_usd)}</td>
                  <td className="font-medium">{fmtUsd(p.total_price_usd)}</td>
                  <td className="text-notion-500">{p.supplier_label ?? p.supplier?.name ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
